// 유틸 함수: 코치 이름에서 " Coach", " 외 n명" 등의 접미사 제거
export const cleanTeacherName = (name) => {
  return typeof name === 'string' ?
    name.replace(/ Coach$/, '').replace(/ 외 \d+명$/, '').trim()
    :
    name;
};
